"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _client = require("@apollo/client");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  mutation removeFavorite($id: Int!) {\n    removeWishlistItem(input: { product_id: $id }) {\n      items {\n        id\n        product {\n          id\n          is_wishlisted\n        }\n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var _default = (0, _client.gql)(_templateObject());

exports.default = _default;